module.exports = __webpack_public_path__ + "static/media/logo2.9b1dd66d.png";